import React from "react";

// Protected Route Component
import ProtectedRoute from "../components/ProtectedRoute";

//pages
import Groups from "../views/dashboard/app/groups";
import GroupDetail from "../views/dashboard/app/group-detail";
import FriendList from "../views/dashboard/app/friend-list";
import ProfileImages from "../views/dashboard/app/profile-images";
import ProfileVideos from "../views/dashboard/app/profile-videos";
import ProfileEvents from "../views/dashboard/app/profile-events";
import EventDetail from "../views/dashboard/app/event-detail";
import Calendar from "../views/dashboard/app/calendar";
import Birthday from "../views/dashboard/app/birthday";
import Weather from "../views/dashboard/app/weather";
import Music from "../views/dashboard/app/music";
import CatergoryGrid from "../views/dashboard/store/store-category-grid";
import CatergoryList from "../views/dashboard/store/store-category-list";
import StoreDetail from "../views/dashboard/store/store-detail";
import StoreCheckout from "../views/dashboard/store/store-checkout";

//market and profile pages
import Market1 from "../views/dashboard/market-place/market1";
import Market2 from "../views/dashboard/market-place/market2";
import Profile1 from "../views/dashboard/profiles/profile1";
import Profile2 from "../views/dashboard/profiles/profile2";
import Profile3 from "../views/dashboard/profiles/profile3";
import ProductDetail from "../views/dashboard/store/product-detail";

export const Layout1Router = [
  {
    path: "app/groups",
    element: <ProtectedRoute><Groups /></ProtectedRoute>,
  },
  {
    path: "app/group-detail",
    element: <ProtectedRoute><GroupDetail /></ProtectedRoute>,
  },
  {
    path: "app/friend-list",
    element: <ProtectedRoute><FriendList /></ProtectedRoute>,
  },
  {
    path: "app/profile-images",
    element: <ProtectedRoute><ProfileImages /></ProtectedRoute>,
  },
  {
    path: "app/profile-videos",
    element: <ProtectedRoute><ProfileVideos /></ProtectedRoute>,
  },
  {
    path: "app/profile-events",
    element: <ProtectedRoute><ProfileEvents /></ProtectedRoute>,
  },
  {
    path: "app/event-detail",
    element: <ProtectedRoute><EventDetail /></ProtectedRoute>,
  },
  {
    path: "app/calendar",
    element: <ProtectedRoute><Calendar /></ProtectedRoute>,
  },
  {
    path: "app/birthday",
    element: <ProtectedRoute><Birthday /></ProtectedRoute>,
  },
  {
    path: "app/weather",
    element: <ProtectedRoute><Weather /></ProtectedRoute>,
  },
  {
    path: "app/music",
    element: <ProtectedRoute><Music /></ProtectedRoute>,
  },
  {
    path: "store/store-category-grid",
    element: <ProtectedRoute><CatergoryGrid /></ProtectedRoute>,
  },
  {
    path: "store/store-category-list",
    element: <ProtectedRoute><CatergoryList /></ProtectedRoute>,
  },
  {
    path: "store/store-detail",
    element: <ProtectedRoute><StoreDetail /></ProtectedRoute>,
  },
  {
    path: "store/store-checkout",
    element: <ProtectedRoute><StoreCheckout /></ProtectedRoute>,
  },
  {
    path:'store/product-detail',
    element:<ProtectedRoute><ProductDetail/></ProtectedRoute>
  },
  {
    path: "market-place/market1",
    element: <ProtectedRoute><Market1 /></ProtectedRoute>,
  },
  {
    path: "market-place/market2",
    element: <ProtectedRoute><Market2 /></ProtectedRoute>,
  },
  {
    path: "profiles/profile1",
    element: <ProtectedRoute><Profile1 /></ProtectedRoute>,
  },
  {
    path: "profiles/profile2",
    element: <ProtectedRoute><Profile2 /></ProtectedRoute>,
  },
  {
    path: "profiles/profile3",
    element: <ProtectedRoute><Profile3 /></ProtectedRoute>,
  },
];
